class CartNotificationPopup extends HTMLElement {
  constructor() {
    super();

    this.$notification = $('#cart-notification-popup');
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  handleHTML(message){
    const html = `
      <div id="line-item-${message.id}" class="cart-notification-card" style="display:none">
      <span><img class="cart-notification-card__close close-btn" src="${this.dataset.closeIcon}" alt="close"></span>

        <div class="cart-notification-card__top">
          <div class="image-wrapper"><img src="${message.image}" alt="${message.product_title}" /></div>
          <div>
            <div class="cart-notification-card__item-title">${message.product_title}</div> 
            <div class="cart-notification-card__add-message">has been added to your cart</div>
          </div>
        </div>
        <div class="cart-notification-card__bottom view-basket">
          <div class="view-basket-text">view your cart</div>
          <div class="view-basket-total">${message.quantity} item${message.quantity > 1 ? 's' : ''} - $${(message.final_line_price / 100).toFixed(2)}</div>
        </div>
      </div>
    `

    if($(`#line-item-${message.id}`).length){
      $(`#line-item-${message.id}`).remove();
    }
    this.$notification.append(html);
    $(`#line-item-${message.id}`).fadeIn();

    $(`#line-item-${message.id} .view-basket`).on('click', ()=>{
      this.cart.open();
    })

    $(`#line-item-${message.id} .close-btn`).on('click', ()=>{
      $(`#line-item-${message.id}`).fadeOut();
    })

    setTimeout(()=>{
      $(`#line-item-${message.id}`).fadeOut(()=>{
        $(`#line-item-${message.id}`).remove();
      });
    }, 5000)
  }

  addMessage(message){
    let html = '';
    if( message.items ){
      const items = message.items;
      const $this = this;

      items.forEach(element => {
        $this.handleHTML(element);  
      });
    } else {
      this.handleHTML(message);  
    }
  }
}

customElements.define('cart-notification-popup', CartNotificationPopup);
